import React from 'react';
import DOMPurify from 'dompurify';
import { API_BASE_URL } from '../../store/constans';
import { FaArrowRight } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-scroll';

const Sections = ({ children, state, to, smooth }) => {

    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate(to)
    }

    {
        if (state?.position === 1) {
            return (
                <div key={state.id} className='flex flex-col h-full md:justify-center items-center p-5 my-5 bg-white/30'>
                    <section className='flex flex-col md:flex-row w-full'>
                        <div className='w-full flex justify-center'>
                            {/* Agregamos un tamaño fijo para evitar el layout shift */}
                            <img
                                className='shadow-lg shadow-gray-500 object-cover'
                                src={API_BASE_URL + state.image}
                                alt={`Imagen de ${state.title}`}
                                width="500"  // Define el tamaño de la imagen
                                height="300" // Define la altura para mantener la proporción
                                loading="lazy"  // Lazy load para mejorar el rendimiento
                            />
                        </div>
                        <div className='w-full flex flex-col md:p-10 transition-all justify-center items-center'>
                            <div className='my-5'>
                                <h3
                                    className='text-[25px] md:text-[40px] text-center md:text-start mb-5 text-p-secundary uppercase'
                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(state.title) }}
                                ></h3>
                                <p
                                    className='text-justify text-[20px] text-gray-500'
                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(state.text) }}
                                ></p>
                            </div>
                            <div className='flex justify-start w-full my-3'>
                                {smooth ? (
                                    <Link
                                        to={to}
                                        smooth={true}
                                        duration={500}
                                        className='cursor-pointer flex gap-5 items-center bg-orange-500 active:scale-95 transition-all hover:scale-110 duration-300 shadow-md shadow-black text-[13px] md:text-[15px] border border-white px-5 py-2 font-bold rounded-full text-white hover:bg-orange-500 hover:border-white'
                                    >
                                        {children}
                                        <FaArrowRight />
                                    </Link>
                                ) : (
                                    <button
                                        onClick={handleNavigate}
                                        className='flex gap-5 items-center bg-orange-500 active:scale-95 transition-all hover:scale-110 duration-300 shadow-md shadow-black text-[13px] md:text-[15px] border border-white px-5 py-2 font-bold rounded-full text-white hover:bg-orange-500 hover:border-white'
                                    >
                                        {children}
                                        <FaArrowRight />
                                    </button>
                                )}
                            </div>
                        </div>
                    </section>
                </div>

            )
        } else if (state?.position === 2) {
            return (
                <div className='flex flex-col h-full my-5 bg-[#f5f5f5]/50 md:justify-center items-center p-5'>
                    <section className='flex flex-col md:flex-row w-full'>
                        <div className={`w-full flex flex-col md:p-10 transition-all justify-center items-center`}>
                            <div className='my-5'>
                                <h3 className='text-[25px] md:text-[40px] text-center md:text-start mb-5 text-p-secundary uppercase' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(state.title) }}></h3>
                                <p className='text-justify text-[20px]' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(state.text) }}></p>
                            </div>
                            <div className='flex justify-start w-full my-3'>
                                {
                                    smooth ?
                                        <Link to={to} smooth={true} duration={500} className=' cursor-pointer flex gap-5 items-center bg-orange-500 active:scale-95 transition-all hover:scale-110 duration-300 shadow-md shadow-black text-[13px] md:text-[15px] border border-white px-5 py-2 font-bold rounded-full text-white hover:bg-orange-500 hover:border-white'>
                                            {children}
                                            <FaArrowRight />
                                        </Link>
                                        :
                                        <button
                                            onClick={handleNavigate}
                                            className='flex gap-5 items-center bg-orange-500 active:scale-95 transition-all hover:scale-110 duration-300 shadow-md shadow-black text-[13px] md:text-[15px] border border-white px-5 py-2 font-bold rounded-full text-white hover:bg-orange-500 hover:border-white'>
                                            {children}
                                            <FaArrowRight />
                                        </button>
                                }
                            </div>
                        </div>
                        <div className={`w-full flex justify-center`}>
                            <img
                                className='shadow-lg shadow-gray-500 object-cover'
                                src={API_BASE_URL + state.image}
                                alt={`Imagen de ${state.title}`}
                                width="500"  // Define el tamaño de la imagen
                                height="300" // Define la altura para mantener la proporción
                                loading="lazy"  // Lazy load para mejorar el rendimiento
                            />
                        </div>
                    </section>
                </div>
            );
        } else if (state?.position === 3) {
            return (
                <div>
                    <div className='flex flex-col md:flex-row gap-5 py-8 justify-between items-center'>
                        <div className='flex justify-end items-end w-full text-[#2e6a82] text-[36px] md:text-[57px] 2xl:text-[60px] text-center md:text-start uppercase font-bold'>
                            <h2 className=' md:w-[80%] leading-none'>We are <br /> smart planet certified</h2>
                        </div>
                        <div className='h-full md:pl-[39px] md:w-full'>
                            <img className='w-full h-[270px] object-cover' loading="lazy" src={API_BASE_URL + state.image} alt={state.image} />
                        </div>
                    </div>
                    <section className="p-3 md:p-6 mb-3 md:px-14">
                        <h2 className="text-[30px] md:text-[40px]" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(state.title) }}></h2>
                        <p className="px-3 md:px-24 text-[17px] text-black text-justify md:text-center" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(state.text) }}></p>
                    </section>
                </div>
            );
        } else if (state?.position === 4) {
            return (
                <section className='flex flex-col md:flex-row md:h-[400px] w-full'>
                    <div className='h-full w-[100%] md:w-[85%]'>
                        <img
                            src={API_BASE_URL + state.image} alt={state.image}
                            className='h-full w-full object-cover' // Estilos de la imagen
                            loading="lazy" // Lazy loading 
                        />
                    </div>
                    <div className={`w-full h-full flex flex-col md:p-10 transition-all bg-[#2c6a80] text-white justify-center items-center`}>
                        <div className='my-3'>
                            <h2 className="text-[25px] md:text-[30px] uppercase px-[10px] text-start font-semibold mb-5" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(state.title) }}></h2>
                            <p className=" text-[16px] text-justify px-[10px]" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(state.text) }}></p>
                        </div>
                    </div>
                </section>
            );
        }
    }
};

export default Sections;